import { useState, useMemo, useEffect, useCallback } from "react";
import { supabase } from "./supabaseClient";

const B = {
  blue:"#0F6BFF", blueDark:"#0A4FCC", blueLight:"#E6F0FF", blueMid:"#BFDBFF",
  black:"#000000", charcoal:"#191919", darkGrey:"#333333", midGrey:"#666666",
  lightGrey:"#BBBBBB", border:"#DDDDDD", offWhite:"#F7F7F7", white:"#FFFFFF",
};

const CATEGORIES = ["Technical Question","Document Request","Product Fault","Installation Help","Compatibility Query","Other"];
const PRIORITIES  = ["Low","Normal","High","Urgent"];
const STATUSES    = ["Open","In Progress","Awaiting Info","Resolved"];
const STAFF_EMAILS = ["scott.m@voltex.com","adam.b@voltex.com"];

const PRODUCT_CODES = ["140A/4TB","140A/4TR","160-BLA","160-BLU","160-EAR","160-MIX","160-RED","160-WHI","165A/13B","165A/13R","165A/7B","165A/7R","350A/13R","350A/7B","350A/7R","3M2155-BLA","AB332","AB443","AB843","ABT1","ABT3","ADM250X","ADM250XKB","ADM250XKDG","ADM250XKW","ADM300SV2","ADP-1QC","AFTV","AH4EMK","AIB","ALVY15","ALVY200/150","AMB40","APP1H","APP1H15","APP1V","APP2H","APP2HUSB2C65","APP2HXWM","APP2V","APP2VUSB2C65","APP2VXWM","ARB-2SQCK","ARB1","ARB2","ARB3","ARJ456","ARMA.BUS.1.12M","ARMA.BUS.1.18M","ARMA.BUS.1MS.12M","ARMA.BUS.1MS.18M","ARMA.BUS.3MS.12M","ARMA.BUS.3MS.18M","ARMALABELKIT","ARPS5-40","ASM10D","ASM16","ASM16FAN","ASM16HEAT","ASM16LIG","ASM16SEN","ASM25D","ASM25DHOB","ASM25DHWS","ASM25DOVEN","ASM3POOC","ASM3PSOO","ASM40","ASM40HOB","ASM40OVEN","ASM40RAN","ASMI","ASW1","ASW1H","ASW1P","ASW2","ASW2H","ASW2P","ASW3","ASW3H","ASW3P","ASW4","ASW4H","ASW4P","ASW5","ASW5H","ASW5P","ASW6","ASW6H","ASW6P","ASWBP","ATVFM","BDL8T90-W","BGN-1038","BGN-620","BGN-625","BGN-632","BGN-635","BGN-641","BGN-645","BGN-720","BGN-725","BGN-732","BGN-745","BGN-750","BGN-865","BGN-875","BLAWPC150","BLC-0.5","BLC-0.75","BLC-1","BLC-1.5","BLC-10","BLC-16","BLC-2.5","BLC-25","BLC-2X0.5","BLC-2X0.75","BLC-2X1","BLC-2X1.5","BLC-2X2.5","BLC-2X4","BLC-2X6","BLC-35","BLC-4","BLC-50","BLC-6","BMP","BTN-812","BTN-815","BTN-820","BTN-825","BTN-825G","BTN-832","BTS-812","BTS-816","BTS-820","BTS-825","BTS-825G","BTS-832","BTW100M","BTW13M","BTW25M","BUS-1P-18M","BUS-1U-12M","BUS-1U-18M","BUS-2P-9M","BUS-3P-6M","BUS-3U-18M","BUS-3U-4M","BUS-3U-6M","BUS-AV6-14M","BUS-AV6-8M","BUS-PC","BUS.1P.18M","BUS.1U.12M","BUS.1U.18M","BUS.3P.6M","BUS.3U.4M","BUS.3U.6M","C5RJ45","C66AI310","C66AI315","C66AI332","C66AI520","C66AI532","C66AI550","C66C310D","C66C310RC","C66C315D","C66C315RC","C66C320","C66C320FD","C66C332","C66C332N","C66C410","C66C410RC","C66C420","C66C420RC","C66C432","C66C440","C66C450","C66C510","C66C510RC","C66C520","C66C520RC","C66C532","C66C532RC","C66C540","C66C550","C66CB4N","C66CEB4","C66CMB","C66CSC310","C66CSC315","C66CSC320","C66CSC332","C66CSC410","C66CSC420","C66CSC432","C66CSC440","C66CSC450","C66CSC510","C66CSC520","C66CSC532","C66CSC540","C66CSC550","C66E1","C66E12","C66E2","C66E3","C66E4","C66E6","C66E9","C66EB","C66ES1","C66ES2","C66L1","C66L2","C66P310","C66P315","C66P320","C66P332","C66P410","C66P420","C66P432","C66P440","C66P450","C66P510","C66P520","C66P532","C66P540","C66P550","C66PA420","C66PA432","C66PA520","C66PA532","C66PA540","C66PC2GR","C66PC2OR","C66SC310RC","C66SC315RC","C66SC332RC","C66SC410RC","C66SC420RC","C66SC510RC","C66SC520RC","C66SC532RC","C66SO310","C66SO315","C66SO320","C66SO320F","C66SO332","C66SO410","C66SO420","C66SO432","C66SO440","C66SO450","C66SO510","C66SO520","C66SO532","C66SO540","C66SO550","C66SW220","C66SW332","C66SW363","C6RJ45","C6RJ45B","CA20-90","CA25-90","CAC10","CAC12","CAC14","CAC2-12","CAT6-305-B","CAT6-305-G","CAT6-305-GR","CAT6-305-Y","CBN-832","CC2020","CC2050","CC2520","CC2550","CC3210","CC3225","CC4010","CC5010","CCD200","CCG20","CCG25","CCG32","CCG40","CCG50","CCL20","CCL25","CCL32","CCO2020","CCO2520","CCO2550","CCO3210","CCO3225","CCO4010","CCO5010","CCS2020","CCS2520","CDL8T89-B","CDL8T89-W","CEB-8045","CFB","CFB48","CFBL","CFBL48","CFERB600","CFERB900","CFERW600","CFERW900","CFLREM","CFREM","CFTV","CFTVB","CFW","CFW48","CFWL","CFWL48","CHDMI","CHS-0840","CHS-0865","CHS-1050","CHS-1060","CHS-1075","CIMB-M","CIMB-MB","CIMB-MBG","CJB","CJBL","CJBL-E","CJBL-L","CJBM","CJBS","CL-1.5","CL-1.5-5","CL-1.5-6","CL-10","CL-10-6","CL-10-8","CL-120","CL-16","CL-2.5","CL-2.5-5","CL-2.5-6","CL-2.5-8","CL-25","CL-35","CL-4","CL-4-6","CL-4-8","CL-50","CL-6","CL-6-10","CL-6-6","CL-6-8","CL-70","CL-95","CL12T275","CL18T275","CL25T350","CMN-5025","CMN-6030","CMT121","CNMG","CNMR","CPP1H","CPP1H15","CPP1V","CPP2H","CPP2HUSB","CPP2HUSBC","CPP2HX","CPP2HXWM","CPP2V","CPP2VXWM","CPP4H","CS20","CS25","CS263","CS32","CS463","CSCP20","CSCP25","CSCT20","CSCT25","CSCT32","CSM10D","CSM16","CSM16FAN","CSM16HEA","CSM16LIG","CSM16SEN","CSM25D","CSM25HOB","CSM25HWS","CSM25OVE","CSM35","CSM35HOB","CSM3P","CSM3PSOO","CSMBLANK","CSMBP","CSMI","CSMR4","CSST3046/100","CSST3646/100","CST-182","CST-183","CST-3162","CST-3163","CSW1","CSW2","CSW3","CSW4","CSW45D","CSW5","CSW6","CSWBP","CTG4.8","CTGSS","CTS1546/100","CTS2046/100","CTS3046/100","CTS32","CTS3646/100","CTVCC","CTVFM","CTVFMB","CTVM","CTW-6560","D1-10","D9025Z","D9040","DIMB","DJ15","DJ20","DJB1-20","DJB1-25","DJB2-20","DJB2-25","DJB3-20","DJB3-25","DJB4-20","DJB4-25","DL9T90-10MM","DLO","DM250X","DM300S","DMKMB","DMSO10","DMSO15","DR150/125","DTY-25","DUCT-BLACK","DUCT-GREY","DUCT-WHITE","DUCTO150","DUCTOKIT","EDLD63","EL20","EL25","EL32","EM-40-1P","EP088","EP20","EP25","ER25","EURO4WG","EURO5WG","EURO6WG","EURO6WR","EURO8WG","EV111","EV161","EX088","EX111","EX161","EX231","EXL","EXLS","EXLSRK","EXT231","FCN-16225","FCN-16227","FCN-16235","FCN-16240","FD6100","FD6125","FD6150","FD6200","FGS-29200","FGS-29300","FKW-15120/NMI","FKW-15130/NMI","FLB-CW/120W","FLB-CW/16W","FLB-CW/200W","FLB-CW/24W","FLB-CW/50W","FLB-CW/72W","FLB-WW/16W","FLB-WW/24W","FMS-12055","FRCC","FRP-L","FRP-M","FRP-S","FRP-XL","FRPC","FRPS5-40","FRS300G","FRS600","FTMS","FTN-1016","FTS-1016","GC20","GC30","GCDSS12510-10","GF150","GL-12","GL-16","GL-20","GL-25","GL-32","GL-40","GL-50","GL-63","GL-6P","GS242","GS243","GS244","GS245","GS246","GS251","GS252","GS253","GS254","GS255","GS256","GSC","GSXT171","GSXT231","GSXT322","GTB2513","HBL-AR","HBL-DS","HBL-PR","HCL-100-CW","HCL-120L","HCL-150-CW","HCL-200-CW","HCL-90L","HCL-AMB","HCL-DSMB","HCS16","HCS20","HCS22","HCS25","HCS32","HCS40","HCS50","HCS63","HH17-1025S","HH17-1250S","HHN-1020","HHS-1016","HHS-1025","HHS-1220","HHS-1255S","HS-MED-12-3","HS-MED-22-6","HS-MED-34-9","HS-MED-40-12","HS-MED-56-17","HS-MIXED-1.5","HS-MIXED-10","HS-MIXED-13","HS-MIXED-2.5","HS-MIXED-20","HS-MIXED-25","HS-MIXED-3.5","HS-MIXED-5","HS-MIXED-7","HSF22","HSF25","HSF32","HSKELW11L","HSV20B","HSV22B","HSV25B","HSV32B","HSV40B","HSV50B","HSV54B","HSV57B","HSV70B","HSV92B","HWA-1810","HWA-18316","HWA-1845","HWA-31610","HWAST-200","IDL7T70-B","IDL7T70-S","IDL7T70-W","IDL7T90-W","IDL9T90-B","IDL9T90-S","IDL9T90-W","IDL9T90-W10","IDLF140","IDLF170","IE20","IE25","IE32","IMS64-2","IMS70","IMS70-SMK","IT20","IT25","IT32","IWT-B","IWT-FR","JB1-20","JB1-25","JB2-20","JB2-20A","JB2-25","JB2-25A","JB3-20","JB3-25","JB4-20","JB4-25","JBLG","JS252","JS253","JTU-20","JTU-25","K9060","K9100","K9250","L12B","L12R","L5B","L5R","L7B","L7R","LBS1240","LBS1240MD","LBS620","LBS620MD","LD13T90-S","LD13T90-W","LD18T160-W","LD23T200-W","LD9T90-W","LDF140","LDF140-S","LDF170","LDF170-S","LF20","LF25","LF32","LPL-CABLE","LPL1230","LPL1230-SM","LPL1260","LPL1260-SM","LPL6060","LPL6060-SM","LW1236-5K","LW1236M-5K","LW1248-5K","LW624-5K","LW624M-5K","MC-25-240-1NO1NC","MC-25-240-2NO","MC-25-240-4NO","MC-40-240-2NO2NC","MC-40-240-4NO","MC-63-240-2NO2NC","MC-63-240-4NO","MC-AC-1NC","MC-AC-1NO","MC-VM","MCB10-1-C10","MCB10-1-C16","MCB10-1-C20","MCB10-1-C25","MCB10-1-C32","MCB10-1-C40","MCB10-1-C50","MCB10-1-C6","MCB10-1-C63","MCB10-3-C10","MCB10-3-C16","MCB10-3-C20","MCB10-3-C25","MCB10-3-C32","MCB10-3-C40","MCB10-3-C50","MCB10-3-C6","MCB10-3-C63","MCB4.5-1-C10","MCB4.5-1-C16","MCB4.5-1-C20","MCB4.5-1-C25","MCB4.5-1-C32","MCB4.5-1-C4","MCB4.5-1-C40","MCB4.5-1-C50","MCB4.5-1-C6","MCB4.5-1-C63","MCB4.5-3-C10","MCB4.5-3-C16","MCB4.5-3-C20","MCB4.5-3-C25","MCB4.5-3-C32","MCB4.5-3-C40","MCB4.5-3-C50","MCB4.5-3-C63","MCB6-1-C10","MCB6-1-C16","MCB6-1-C2","MCB6-1-C20","MCB6-1-C25","MCB6-1-C32","MCB6-1-C4","MCB6-1-C40","MCB6-1-C50","MCB6-1-C6","MCB6-1-C63","MCB6-3-C10","MCB6-3-C16","MCB6-3-C20","MCB6-3-C25","MCB6-3-C32","MCB6-3-C40","MCB6-3-C50","MCB6-3-C63","MDRC20","MDRC25","MF100","MF150","MF200","ML-0410R","ML-0421","ML-0497A","ML-CBL","ML-S697","MRPS5-45","MS1-100","MS2-100","MS3-100","MSE252015","MSE302515","MSE303020","MSE403020","MSE404020","MSE504020","MSE505020","MSEKEY","NIA-5025","NIA-5040","NIA-6525","NIA-6538","NS1465SM","NS3865","NS3865SM","NS51665","NSB19","NSB22","NSB26","NSB30","NSB32","OFL30B","OFL30W","OMS-180B","OMS-180W","OMS-360","OMS-360C","OMSL2B","OMSL2W","OPP1H","OPP1H15","OPP2H","OPP2H15","OPP2HX","OPP2HXWM","OS05B","OS06A","OS06A15","OSW1","OSW2","OSW3","OSW4","OSW5","OSW6","OSWB","OSWBP","PB00-10","PB00-13","PB00S-6","PB10","PB20","PB30","PB30S","PB50","PB60","PB80","PB90","PBSM-ELV","PH2100SH","PH2100SM","PH2100SMH","PH2150SM","PH2150SMH","PH250SMH","PH275SMH","PHN-620","PHN-630","PHN-712","PHN-720","PHN-725","PHN-730","PHN-740","PHN-750","PHS-816","PLD1","PLD2","PLD5","PLD7","PLD9","PP24C6","PPC6","PPS18","PPS32","PPS50","PS20","PS25","PS32","PS40","PS50","PSF12W","PSF18W","PSF24W","PSF36W","PSFWEDGE","PSS12","PSS12W","PSS18","PSS18W","PSS24","PSS24W","PSS36","PSS36W","RB-HSS","RB-TCT","RB2.5","RCBO4.5-1-10U","RCBO4.5-1-16U","RCBO4.5-1-20U","RCBO4.5-1-25U","RCBO4.5-1-32U","RCBO4.5-1-6U","RCBO6-1-10U","RCBO6-1-13U","RCBO6-1-16U","RCBO6-1-20U","RCBO6-1-25U","RCBO6-1-32U","RCBO6-1-40U","RCBO6-1-6U","RCD40-2","RCD40-4","RCD63-2","RCD63-4","RD25/20","RD32/25","RL-1.5","RPS25-70","RPS3-20","RPS5-45","RWB","RWG100","S300-N","SA-11-150-3P","SA-11-50-1P","SA-RC","SAS115BW","SAS120BW","SAS160B","SAS9VALK1","SAS9VALK12","SASBATL3V","SASBATL9V","SASFM","SASMH9V","SASMH9VALK","SASMH9VRF","SASREM","SB-PF","SB20-90","SB25-90","SB32-90","SB40-90","SB50-90","SBC","SBC-S","SBF-12W","SBF-18W","SBS-12","SBS-18","SBS-4","SBS-6","SBS-8","SC-1","SC-2","SC-3","SC-4","SC20","SC25","SCC2550","SCRD25/20","SCRD32/25","SCRD40/32","SCWP75","SDP","SDS050160","SDS050210","SDS060160","SDS060210","SDS060460","SDS080160","SDS080210","SDS100160","SDS100210","SDS120160","SDS160450","SDS200450","SDS250450","SDS260450","SE20","SE25","SLPP1H","SLPP1H15","SLPP2H","SLPP2HUSB","SLPP2HUSBC","SLPP2HX","SLPP2HXWM","SLPP2V","SLPP2VXWM","SLSS","SLSW1","SLSW2","SLSW3","SLSW4","SLSW5","SLSW6","SLSWBP","V-230LT","V-305","V157","V157D","V255","VBH","VBHE-2L","VBHE-4L","VBHF","VBT","VCR","VCSG","VDEP","VDREF","VDREF-LED","VDSEF","VEF-200","VEF-250","VLC-412","VLC-413","VLC-415","VMB16","VMB20","VMB34","VMB4","VPO-10","VPO-15","VRES","VRES-15","VRPT","VRPT-15","VWBHF","WF150","WF150-KIT","WPB","WPB-3800","WPB-5000","WPG-2500","WPG-3000","WPG-3800","WPG-5000","WPP1H","WPP1H-15","WPP2H","WPP2H-15","WPP2H-54","WPP2HS","WPP2HX","WPS140V2","WPS220V2","WPS363V2","WPSS-16","WPSS1","WS1-16V2","WS2-16V2","WSBS-12","WSBS-18","WSBS-24","WSBS-36","WSBS-6","WSBS-8","WSBS-L","ZIM-1000","ZIM-2346","ZIN-2000","ZIN-2345","ZIN-2350"];

const PRIORITY_COLORS = {
  Low:    { bg:"#E8F5E9", text:"#2E7D32", dot:"#4CAF50" },
  Normal: { bg:"#E3F2FD", text:"#1565C0", dot:"#2196F3" },
  High:   { bg:"#FFF3E0", text:"#BF360C", dot:"#FF6D00" },
  Urgent: { bg:"#FDECEA", text:"#B71C1C", dot:"#E53935" },
};
const STATUS_COLORS = {
  Open:            { bg:"#F3E5F5", text:"#6A1B9A" },
  "In Progress":   { bg:B.blueLight, text:B.blueDark },
  "Awaiting Info": { bg:"#E0F7FA", text:"#006064" },
  Resolved:        { bg:"#E8F5E9", text:"#1B5E20" },
};

function formatDate(ts) {
  const d = new Date(ts);
  return d.toLocaleDateString("en-AU",{day:"2-digit",month:"short",year:"numeric"}) + " " +
    d.toLocaleTimeString("en-AU",{hour:"2-digit",minute:"2-digit"});
}
function genId() { return `VTX-${Date.now().toString(36).toUpperCase()}`; }
const EMPTY_CUST = { name:"", company:"", phone:"", email:"", notes:"", country:"AU" };

function isStaffUser(email) {
  return email && STAFF_EMAILS.includes(email.toLowerCase());
}

function sendBrowserNotification(title, body, tag) {
  if (!("Notification" in window) || Notification.permission !== "granted") return;
  const canvas = document.createElement("canvas");
  canvas.width = 128; canvas.height = 128;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#000000";
  ctx.beginPath(); ctx.roundRect(0,0,128,128,16); ctx.fill();
  ctx.save();
  ctx.scale(128/42, 128/42);
  ctx.translate(2, 0);
  ctx.fillStyle = "#ffffff";
  const p = new Path2D("M36.74.12c-.66-.44-1.38.51-1.38.51L13.92,28.19c-2.56,3.36-4.31.45-4.31.45L1.38,13.62c-.15-.33-.6-.85-1.1-.63-.49.23-.18,1.16-.18,1.16l8.67,26.26s.51,1.66,2.46,1.66c.81,0,1.76-.43,2.76-1.9L36.66,1.48c.17-.32.53-1.06.08-1.36Z");
  ctx.fill(p);
  ctx.restore();
  const icon = canvas.toDataURL("image/png");
  const n = new Notification(title, { body, tag, icon, requireInteraction:false });
  n.onclick = () => { window.focus(); n.close(); };
}

function playNotificationSound() {
  try {
    if (!window._vxAudioCtx) window._vxAudioCtx = new (window.AudioContext || window.webkitAudioContext)();
    const ctx = window._vxAudioCtx;
    const play = () => {
      [880, 1100].forEach((freq, i) => {
        const osc = ctx.createOscillator(); const gain = ctx.createGain();
        osc.connect(gain); gain.connect(ctx.destination);
        osc.type = "sine"; osc.frequency.value = freq;
        const t = ctx.currentTime + i * 0.15;
        gain.gain.setValueAtTime(0, t);
        gain.gain.linearRampToValueAtTime(1.0, t + 0.01);
        gain.gain.exponentialRampToValueAtTime(0.001, t + 0.4);
        osc.start(t); osc.stop(t + 0.4);
      });
    };
    if (ctx.state === "suspended") { ctx.resume().then(play); } else { play(); }
  } catch(e) {}
}

function triggerNotification(type, priority, ticketTitle, tag) {
  const title = type === "ticket" ? `New Ticket — ${priority}` : `New Reply`;
  sendBrowserNotification(title, ticketTitle, tag);
  playNotificationSound();
}

function VoltexLogo({ height = 34 }) {
  return (
    <svg height={height} viewBox="0 0 148.44 42.08" fill="none" xmlns="http://www.w3.org/2000/svg" style={{display:"block"}}>
      <g fill="#ffffff">
        <path d="M44.38,31.79c-.83,1.84-1.89,3.21-3.16,4.12-1.27.9-2.6,1.35-3.98,1.35-1.7,0-3.06-.57-4.11-1.72-1.04-1.15-1.57-2.57-1.57-4.27,0-2.78.78-5.32,2.36-7.63,1.57-2.33,3.6-3.48,6.09-3.48,1.63,0,2.98.56,4.03,1.67,1.05,1.11,1.58,2.63,1.58,4.58,0,1.74-.42,3.54-1.25,5.38M40.4,15.92c-2.28,0-4.32.47-6.1,1.4-1.8.93-3.28,2.19-4.45,3.79-1.17,1.59-2.05,3.47-2.62,5.65-.44,1.61-.66,3.17-.66,4.63,0,1.58.32,3.13.98,4.68.65,1.54,1.76,2.84,3.32,3.88,1.57,1.05,3.5,1.57,5.81,1.57,2.66,0,5.04-.65,7.14-1.97,2.11-1.32,3.77-3.2,5-5.63,1.22-2.44,1.84-4.96,1.84-7.57,0-3.13-.94-5.65-2.82-7.55-1.89-1.9-4.36-2.86-7.42-2.86Z"/>
        <polygon points="140.39 16.36 133.92 16.36 127.18 24.01 123.18 16.36 117.85 16.36 123.71 27.96 112.07 41.19 118.72 41.19 126.11 32.71 130.4 41.19 136.17 41.19 129.63 28.69 140.39 16.36"/>
        <path d="M57.92,35.63l4.02-19.15h-5.1l-4.64,22.13s-.75,2.68,2.49,2.68h14.67l.86-4.13h-11.15s-1.59.17-1.15-1.54Z"/>
        <polygon points="92.16 16.41 70.6 16.41 69.78 20.54 78.09 20.54 73.76 41.24 78.85 41.24 83.19 20.54 91.33 20.54 92.16 16.41"/>
        <path d="M99.21,20.54h13.28l.87-4.13h-17c-1.39,0-1.64,1.23-1.64,1.23l-4.47,21.33s-.6,2.26,1.28,2.27h17.66l.86-4.13h-14.34l1.42-6.75h12.98l.85-4.14h-12.95l1.21-5.68Z"/>
        <path d="M36.74.12c-.66-.44-1.38.51-1.38.51L13.92,28.19c-2.56,3.36-4.31.45-4.31.45L1.38,13.62c-.15-.33-.6-.85-1.1-.63-.49.23-.18,1.16-.18,1.16l8.67,26.26s.51,1.66,2.46,1.66c.81,0,1.76-.43,2.76-1.9L36.66,1.48c.17-.32.53-1.06.08-1.36Z"/>
        <path d="M144.95,18.73h.58c.28,0,.47-.04.57-.12s.15-.19.15-.33c0-.09-.02-.17-.07-.24-.05-.07-.12-.12-.2-.16-.09-.03-.25-.05-.48-.05h-.54v.89M144.48,20.4v-2.97h1.02c.35,0,.6.03.76.08.16.05.28.15.37.29.09.14.14.28.14.43,0,.22-.08.41-.23.57-.15.16-.36.25-.62.27.1.04.19.1.25.16.12.12.27.31.44.59l.36.58h-.58l-.26-.47c-.21-.37-.37-.6-.5-.69-.09-.07-.22-.1-.38-.1h-.28v1.26h-.48M145.68,16.58c-.39,0-.76.1-1.13.3-.37.2-.65.48-.86.85-.21.37-.31.75-.31,1.15s.1.78.31,1.14.49.65.85.85c.37.2.75.31,1.14.31s.78-.1,1.14-.31c.37-.2.65-.49.85-.85s.3-.74.3-1.14-.1-.78-.31-1.15c-.21-.37-.49-.65-.86-.85-.37-.2-.74-.3-1.13-.3M145.68,16.12c.46,0,.91.12,1.36.36.44.24.78.58,1.03,1.02.25.44.37.9.37,1.38s-.12.93-.36,1.37c-.24.44-.58.78-1.02,1.02-.44.24-.89.36-1.37.36s-.93-.12-1.37-.36c-.44-.24-.78-.58-1.02-1.02-.24-.44-.37-.89-.37-1.37s.12-.94.37-1.38c.25-.44.59-.78,1.03-1.02.44-.24.89-.36,1.36-.36Z"/>
      </g>
    </svg>
  );
}

function PriorityBadge({ p }) {
  const c = PRIORITY_COLORS[p];
  return <span style={{display:"inline-flex",alignItems:"center",gap:5,padding:"3px 9px",borderRadius:20,fontSize:11,fontWeight:700,background:c.bg,color:c.text}}>
    <span style={{width:6,height:6,borderRadius:"50%",background:c.dot,flexShrink:0}}/>{p}
  </span>;
}
function StatusBadge({ s }) {
  const c = STATUS_COLORS[s];
  return <span style={{display:"inline-block",padding:"3px 9px",borderRadius:20,fontSize:11,fontWeight:600,background:c.bg,color:c.text}}>{s}</span>;
}
function Avatar({ name }) {
  const isStaff = ["Scott","Adam"].includes(name?.split(" ")[0]);
  return <div style={{width:32,height:32,borderRadius:"50%",background:isStaff?B.blue:B.blueLight,color:isStaff?B.white:B.blueDark,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:800,flexShrink:0}}>{(name||"?").charAt(0).toUpperCase()}</div>;
}
function SecLabel({ children, style={} }) {
  return <div style={{fontSize:10,fontWeight:800,color:B.lightGrey,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:10,...style}}>{children}</div>;
}
function Spinner() {
  return <div style={{display:"flex",alignItems:"center",justifyContent:"center",padding:60}}>
    <div style={{width:36,height:36,border:`3px solid ${B.border}`,borderTop:`3px solid ${B.blue}`,borderRadius:"50%",animation:"spin 0.8s linear infinite"}}/>
    <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
  </div>;
}

function LoginScreen() {
  const [error,setError]=useState(""); const [loading,setLoading]=useState(false);

  async function handleMicrosoftLogin() {
    setLoading(true); setError("");
    const { error } = await supabase.auth.signInWithOAuth({
      provider: "azure",
      options: {
        scopes: "email profile openid",
        redirectTo: window.location.origin,
      }
    });
    if (error) { setError(error.message); setLoading(false); }
  }

  return (
    <div style={{minHeight:"100vh",background:B.black,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",fontFamily:"'Inter','Segoe UI',sans-serif"}}>
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap" rel="stylesheet"/>
      <div style={{marginBottom:32}}><VoltexLogo height={32}/></div>
      <div style={{background:B.white,borderRadius:12,padding:36,width:"100%",maxWidth:380,boxShadow:"0 8px 40px rgba(0,0,0,0.4)"}}>
        <div style={{marginBottom:28,textAlign:"center"}}>
          <div style={{fontSize:18,fontWeight:800,marginBottom:6}}>Sign in</div>
          <div style={{fontSize:13,color:B.midGrey}}>Voltex Product Tech Support</div>
        </div>
        {error && <div style={{background:"#FDECEA",color:"#B71C1C",border:"1px solid #FFCDD2",borderRadius:6,padding:"9px 12px",fontSize:13,marginBottom:16}}>{error}</div>}
        <button
          onClick={handleMicrosoftLogin}
          disabled={loading}
          style={{width:"100%",background:B.white,color:B.charcoal,border:`1.5px solid ${B.border}`,borderRadius:7,padding:"11px 16px",fontSize:14,fontWeight:600,cursor:loading?"not-allowed":"pointer",opacity:loading?0.7:1,fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"center",gap:12}}>
          <svg width="20" height="20" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
            <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
            <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
            <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
          </svg>
          {loading ? "Redirecting…" : "Sign in with Microsoft"}
        </button>
        <div style={{marginTop:20,fontSize:11,color:B.lightGrey,textAlign:"center"}}>Use your Voltex Microsoft account</div>
      </div>
      <div style={{marginTop:24,fontSize:11,color:"rgba(255,255,255,0.3)"}}>AU: 1300 722 275 · NZ: 0800 55 66 33</div>
    </div>
  );
}

function SetPasswordScreen({ onDone }) {
  const [password,setPassword]=useState(""); const [password2,setPassword2]=useState("");
  const [error,setError]=useState(""); const [loading,setLoading]=useState(false);
  const [done,setDone]=useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (password.length < 6) { setError("Password must be at least 6 characters."); return; }
    if (password !== password2) { setError("Passwords don't match."); return; }
    setLoading(true); setError("");
    const { error } = await supabase.auth.updateUser({ password });
    if (error) { setError(error.message); setLoading(false); return; }
    setDone(true); setLoading(false);
    setTimeout(() => onDone(), 2000);
  }

  const inp = { width:"100%", border:`1.5px solid ${B.border}`, borderRadius:7, padding:"10px 12px", fontSize:13, outline:"none", fontFamily:"inherit", boxSizing:"border-box" };

  return (
    <div style={{minHeight:"100vh",background:B.black,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",fontFamily:"'Inter','Segoe UI',sans-serif"}}>
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap" rel="stylesheet"/>
      <div style={{marginBottom:32}}><VoltexLogo height={32}/></div>
      <div style={{background:B.white,borderRadius:12,padding:36,width:"100%",maxWidth:380,boxShadow:"0 8px 40px rgba(0,0,0,0.4)"}}>
        <div style={{marginBottom:24}}>
          <div style={{fontSize:18,fontWeight:800,marginBottom:4}}>Set your password</div>
          <div style={{fontSize:13,color:B.midGrey}}>Welcome to Voltex Product Tech Support</div>
        </div>
        {done ? (
          <div style={{background:B.blueLight,color:B.blueDark,border:`1px solid ${B.blueMid}`,borderRadius:6,padding:"9px 12px",fontSize:13}}>Password set — signing you in…</div>
        ) : <>
          {error && <div style={{background:"#FDECEA",color:"#B71C1C",border:"1px solid #FFCDD2",borderRadius:6,padding:"9px 12px",fontSize:13,marginBottom:16}}>{error}</div>}
          <form onSubmit={handleSubmit}>
            <div style={{marginBottom:14}}>
              <label style={{display:"block",fontSize:12,fontWeight:600,color:B.charcoal,marginBottom:5}}>New password</label>
              <input type="password" required value={password} onChange={e=>setPassword(e.target.value)} placeholder="At least 6 characters" style={inp}/>
            </div>
            <div style={{marginBottom:20}}>
              <label style={{display:"block",fontSize:12,fontWeight:600,color:B.charcoal,marginBottom:5}}>Confirm password</label>
              <input type="password" required value={password2} onChange={e=>setPassword2(e.target.value)} placeholder="Re-enter password" style={inp}/>
            </div>
            <button type="submit" disabled={loading} style={{width:"100%",background:B.blue,color:B.white,border:"none",borderRadius:7,padding:"11px",fontSize:14,fontWeight:700,cursor:loading?"not-allowed":"pointer",opacity:loading?0.7:1,fontFamily:"inherit"}}>
              {loading?"Saving…":"Set Password & Get Started"}
            </button>
          </form>
        </>}
      </div>
      <div style={{marginTop:24,fontSize:11,color:"rgba(255,255,255,0.3)"}}>AU: 1300 722 275 · NZ: 0800 55 66 33</div>
    </div>
  );
}

export default function App() {
  const [session,setSession]=useState(null);
  const [authReady,setAuthReady]=useState(false);
  const [resetMode,setResetMode]=useState(false);

  useEffect(() => {
    const hash = window.location.hash;
    const fullUrl = window.location.href;
    const isInviteUrl = hash.includes('type=invite') || fullUrl.includes('type=invite');

    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session); setAuthReady(true);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "PASSWORD_RECOVERY") {
        setResetMode(true); setSession(session);
      } else if (event === "SIGNED_IN" && session) {
        const neverSignedIn = !session.user.last_sign_in_at;
        if (isInviteUrl || neverSignedIn) {
          setResetMode(true);
          window.history.replaceState(null, '', '/');
        } else if (resetMode) {
          setResetMode(false);
        }
        setSession(session);
      } else {
        setSession(session);
      }
    });
    return () => subscription.unsubscribe();
  }, []);

  if (!authReady) return <div style={{minHeight:"100vh",background:B.black,display:"flex",alignItems:"center",justifyContent:"center"}}><Spinner/></div>;
  if (!session) return <LoginScreen/>;
  return <TicketApp session={session}/>;
}

function TicketApp({ session }) {
  const rawName = session.user.email.split("@")[0].split(".");
  const userName = rawName.length >= 2
    ? rawName[0].charAt(0).toUpperCase() + rawName[0].slice(1) + " " + rawName[1].charAt(0).toUpperCase()
    : rawName[0].charAt(0).toUpperCase() + rawName[0].slice(1);

  const [tickets,setTickets]=useState([]);
  const [loading,setLoading]=useState(true);
  const [view,setView]=useState("board");
  const [fStatus,setFStatus]=useState("All");
  const [fPriority,setFPriority]=useState("All");
  const [fCategory,setFCategory]=useState("All");
  const [fCountry,setFCountry]=useState("All");
  const [search,setSearch]=useState("");
  const [comment,setComment]=useState("");
  const [selId,setSelId]=useState(null);
  const [editCust,setEditCust]=useState(false);
  const [custDraft,setCustDraft]=useState(EMPTY_CUST);
  const [editTicket,setEditTicket]=useState(false);
  const [ticketDraft,setTicketDraft]=useState({title:"",category:"",priority:"",description:""});
  const [savingTicket,setSavingTicket]=useState(false);
  const [uploading,setUploading]=useState(false);
  const [savingCust,setSavingCust]=useState(false);
  const [posting,setPosting]=useState(false);
  const [unreadCount,setUnreadCount]=useState(0);
  const [unreadTicketIds,setUnreadTicketIds]=useState(new Set());
  const [selectedIds,setSelectedIds]=useState(new Set());
  const [notifPermission,setNotifPermission]=useState(typeof Notification!=="undefined"?Notification.permission:"denied");
  const [pendingFiles,setPendingFiles]=useState([]);
  const [notifyUser,setNotifyUser]=useState("");
  const [allUsers,setAllUsers]=useState([]);
  const [form,setForm]=useState({title:"",category:"Technical Question",priority:"Normal",submittedBy:userName,description:"",customer:{...EMPTY_CUST}});
  const [formErr,setFormErr]=useState("");
  const [submitting,setSubmitting]=useState(false);
  const [resolvedExpanded,setResolvedExpanded]=useState(false);
  const [productSearch,setProductSearch]=useState("");
  const [productSuggestions,setProductSuggestions]=useState([]);
  const [showSuggestions,setShowSuggestions]=useState(false);
  const [editingCommentId,setEditingCommentId]=useState(null);
  const [editingCommentText,setEditingCommentText]=useState("");
  const [savingComment,setSavingComment]=useState(false);

  const loadTickets = useCallback(async () => {
    setLoading(true);
    const { data: ticketRows, error } = await supabase.from("tickets").select("*").order("created_at",{ascending:false});
    if (error) { setLoading(false); return; }
    const { data: commentRows } = await supabase.from("comments").select("*").order("created_at",{ascending:true});
    const { data: attachmentRows } = await supabase.from("attachments").select("*").order("created_at",{ascending:true});
    setTickets(ticketRows.map(t => ({
      id:t.id, title:t.title, category:t.category, priority:t.priority,
      status:t.status, submittedBy:t.submitted_by, assignedTo:t.assigned_to||"",
      description:t.description, created:new Date(t.created_at).getTime(),
      customer:{name:t.customer_name||"",company:t.customer_company||"",phone:t.customer_phone||"",email:t.customer_email||"",notes:t.customer_notes||"",country:t.customer_country||"AU"},
      comments:(commentRows||[]).filter(c=>c.ticket_id===t.id).map(c=>({id:c.id,author:c.author,time:new Date(c.created_at).getTime(),text:c.body})),
      attachments:(attachmentRows||[]).filter(a=>a.ticket_id===t.id).map(a=>({id:a.id,name:a.file_name,path:a.file_path,size:a.file_size,type:a.mime_type,uploadedBy:a.uploaded_by,time:new Date(a.created_at).getTime()})),
      watchers:t.watchers||[],
    })));
    setLoading(false);
  }, []);

  useEffect(() => { loadTickets(); }, [loadTickets]);

  useEffect(() => {
    async function loadUsers() {
      const { data, error } = await supabase.from("profiles").select("display_name").order("display_name");
      if (!error && data) setAllUsers(data.map(p => p.display_name));
    }
    loadUsers();
  }, []);

  useEffect(() => {
    if ("Notification" in window) setNotifPermission(Notification.permission);
    const warmUp = () => {
      try {
        if (!window._vxAudioCtx) window._vxAudioCtx = new (window.AudioContext || window.webkitAudioContext)();
        if (window._vxAudioCtx.state === "suspended") window._vxAudioCtx.resume();
      } catch(e) {}
    };
    document.addEventListener("click", warmUp, { once: true });
    return () => document.removeEventListener("click", warmUp);
  }, []);

  useEffect(() => {
    document.title = unreadCount > 0 ? `🔔 (${unreadCount}) Voltex Tech Support` : "Voltex Product Tech Support";
  }, [unreadCount]);

  useEffect(() => { if (view==="board"||view==="list"||view==="product") { setUnreadCount(0); } }, [view]);

  useEffect(() => {
    let channel; let reconnectTimer; let keepaliveTimer;

    function subscribe() {
      if (channel) supabase.removeChannel(channel);
      channel = supabase.channel("db-changes")
        .on("postgres_changes",{event:"INSERT",schema:"public",table:"tickets"},(payload) => {
          loadTickets();
          if (!isStaffUser(session.user.email)) return;
          const t = payload.new;
          if (t.submitted_by === userName) return;
          triggerNotification("ticket", t.priority, t.title, t.id+"-new");
          setUnreadCount(c=>c+1);
        })
        .on("postgres_changes",{event:"INSERT",schema:"public",table:"comments"},async (payload) => {
          loadTickets();
          const c = payload.new;
          if (c.author === userName) return;
          const { data: ticketData } = await supabase.from("tickets").select("submitted_by,watchers,title").eq("id",c.ticket_id).single();
          const isWatcher = ticketData?.watchers?.includes(userName);
          const isSubmitter = ticketData?.submitted_by === userName;
          if (isStaffUser(session.user.email) || isSubmitter || isWatcher) {
            triggerNotification("comment", null, `${ticketData?.title||""}:\n${c.body?.slice(0,60)||"New reply"}`, c.id+"-reply");
            setUnreadCount(prev=>prev+1);
            setUnreadTicketIds(prev=>new Set([...prev, c.ticket_id]));
          }
        })
        .on("postgres_changes",{event:"UPDATE",schema:"public",table:"tickets"},() => { loadTickets(); })
        .on("postgres_changes",{event:"UPDATE",schema:"public",table:"comments"},() => { loadTickets(); })
        .on("postgres_changes",{event:"DELETE",schema:"public",table:"comments"},() => { loadTickets(); })
        .on("postgres_changes",{event:"DELETE",schema:"public",table:"tickets"},(payload) => { setTickets(p=>p.filter(t=>t.id!==payload.old.id)); })
        .subscribe((status) => {
          if (status==="CHANNEL_ERROR"||status==="TIMED_OUT"||status==="CLOSED") {
            clearTimeout(reconnectTimer);
            reconnectTimer = setTimeout(()=>subscribe(), 3000);
          }
        });

      clearInterval(keepaliveTimer);
      keepaliveTimer = setInterval(() => {
        if (channel) { supabase.removeChannel(channel); subscribe(); }
      }, 60 * 1000);
    }

    subscribe();
    function handleVisibility() { if (document.visibilityState==="visible") { subscribe(); loadTickets(); } }
    document.addEventListener("visibilitychange", handleVisibility);
    return () => {
      clearTimeout(reconnectTimer); clearInterval(keepaliveTimer);
      document.removeEventListener("visibilitychange", handleVisibility);
      if (channel) supabase.removeChannel(channel);
    };
  }, [loadTickets, session.user.email, userName]);

  const live = tickets.find(t=>t.id===selId);
  const filtered = useMemo(() => tickets.filter(t => {
    if (fStatus!=="All"&&t.status!==fStatus) return false;
    if (fPriority!=="All"&&t.priority!==fPriority) return false;
    if (fCategory!=="All"&&t.category!==fCategory) return false;
    if (fCountry!=="All"&&(t.customer?.country||"AU")!==fCountry) return false;
    if (search) {
      const q=search.toLowerCase();
      return t.title.toLowerCase().includes(q)||t.id.toLowerCase().includes(q)||
        t.description.toLowerCase().includes(q)||(t.customer?.name||"").toLowerCase().includes(q)||(t.customer?.company||"").toLowerCase().includes(q);
    }
    return true;
  }), [tickets,fStatus,fPriority,fCategory,fCountry,search]);

  const stats = useMemo(() => ({
    open:tickets.filter(t=>t.status==="Open").length,
    inProgress:tickets.filter(t=>t.status==="In Progress").length,
    awaiting:tickets.filter(t=>t.status==="Awaiting Info").length,
    resolved:tickets.filter(t=>t.status==="Resolved").length,
    urgent:tickets.filter(t=>t.priority==="Urgent"&&t.status!=="Resolved").length,
  }), [tickets]);

  async function submitTicket() {
    if (!form.title.trim()||!form.submittedBy.trim()||!form.description.trim()) { setFormErr("Title, your name, and description are required."); return; }
    setSubmitting(true);
    const id = genId();
    const { error } = await supabase.from("tickets").insert({
      id, title:form.title, category:form.category, priority:form.priority,
      status:"Open", submitted_by:form.submittedBy, assigned_to:"", customer_country:form.customer.country||"AU",
      description:form.description, customer_name:form.customer.name,
      customer_company:form.customer.company, customer_phone:form.customer.phone,
      customer_email:form.customer.email, customer_notes:form.customer.notes,
    });
    if (error) { setFormErr(error.message); setSubmitting(false); return; }
    if (pendingFiles.length > 0) {
      for (const file of pendingFiles) {
        const ext = file.name.split(".").pop();
        const path = `${id}/${Date.now()}-${Math.random().toString(36).slice(2)}.${ext}`;
        const { error: uploadError } = await supabase.storage.from("ticket-attachments").upload(path, file);
        if (!uploadError) {
          await supabase.from("attachments").insert({ticket_id:id,file_name:file.name,file_path:path,file_size:file.size,mime_type:file.type,uploaded_by:userName});
        }
      }
    }
    await loadTickets();
    setForm({title:"",category:"Technical Question",priority:"Normal",submittedBy:userName,description:"",customer:{...EMPTY_CUST}});
    setPendingFiles([]); setFormErr(""); setSubmitting(false); setView("list");
  }

  async function saveTicketEdit(id) {
    setSavingTicket(true);
    await supabase.from("tickets").update({title:ticketDraft.title,category:ticketDraft.category,priority:ticketDraft.priority,description:ticketDraft.description}).eq("id",id);
    setTickets(p=>p.map(t=>t.id===id?{...t,...ticketDraft}:t));
    setSavingTicket(false); setEditTicket(false);
  }

  async function updateStatus(id, status) {
    await supabase.from("tickets").update({status}).eq("id",id);
    setTickets(p=>p.map(t=>t.id===id?{...t,status}:t));
  }
  async function assignTicket(id, name) {
    const newStatus = tickets.find(t=>t.id===id)?.status==="Open"?"In Progress":undefined;
    await supabase.from("tickets").update({assigned_to:name,...(newStatus?{status:newStatus}:{})}).eq("id",id);
    setTickets(p=>p.map(t=>t.id===id?{...t,assignedTo:name,...(newStatus?{status:newStatus}:{})}:t));
  }
  async function postComment(id, resolve=false) {
    if (!comment.trim()) return;
    setPosting(true);
    const { data, error } = await supabase.from("comments").insert({ticket_id:id,author:userName,body:comment}).select().single();
    if (!error) {
      if (notifyUser) {
        const ticket = tickets.find(t=>t.id===id);
        const currentWatchers = ticket?.watchers || [];
        if (!currentWatchers.includes(notifyUser)) {
          const newWatchers = [...currentWatchers, notifyUser];
          await supabase.from("tickets").update({watchers:newWatchers}).eq("id",id);
          setTickets(p=>p.map(t=>t.id===id?{...t,watchers:newWatchers}:t));
        }
      }
      setTickets(p=>p.map(t=>t.id!==id?t:{...t,comments:[...t.comments,{id:data.id,author:userName,time:Date.now(),text:comment}],...(resolve?{status:"Resolved"}:{})}));
      if (resolve) await supabase.from("tickets").update({status:"Resolved"}).eq("id",id);
      setComment(""); setNotifyUser("");
    }
    setPosting(false);
  }

  async function saveCommentEdit(commentId, ticketId) {
    if (!editingCommentText.trim()) return;
    setSavingComment(true);
    const { error } = await supabase.from("comments").update({body:editingCommentText}).eq("id",commentId);
    if (!error) {
      setTickets(p=>p.map(t=>t.id!==ticketId?t:{...t,comments:t.comments.map(c=>c.id===commentId?{...c,text:editingCommentText}:c)}));
      setEditingCommentId(null); setEditingCommentText("");
    }
    setSavingComment(false);
  }

  async function deleteComment(commentId, ticketId) {
    if (!window.confirm("Delete this comment? This cannot be undone.")) return;
    const { error } = await supabase.from("comments").delete().eq("id",commentId);
    if (!error) {
      setTickets(p=>p.map(t=>t.id!==ticketId?t:{...t,comments:t.comments.filter(c=>c.id!==commentId)}));
    }
  }

  async function saveCustomer(id) {
    setSavingCust(true);
    await supabase.from("tickets").update({customer_name:custDraft.name,customer_company:custDraft.company,customer_phone:custDraft.phone,customer_email:custDraft.email,customer_notes:custDraft.notes,customer_country:custDraft.country||"AU"}).eq("id",id);
    setTickets(p=>p.map(t=>t.id===id?{...t,customer:{...custDraft}}:t));
    setSavingCust(false); setEditCust(false);
  }
  async function uploadFile(ticketId, file) {
    setUploading(true);
    const ext=file.name.split(".").pop();
    const path=`${ticketId}/${Date.now()}.${ext}`;
    const { error: uploadError } = await supabase.storage.from("ticket-attachments").upload(path, file);
    if (uploadError) { alert("Upload failed: "+uploadError.message); setUploading(false); return; }
    const { error: dbError } = await supabase.from("attachments").insert({ticket_id:ticketId,file_name:file.name,file_path:path,file_size:file.size,mime_type:file.type,uploaded_by:userName});
    if (!dbError) await loadTickets();
    setUploading(false);
  }
  async function getFileUrl(path) {
    const { data } = await supabase.storage.from("ticket-attachments").createSignedUrl(path, 3600);
    if (data?.signedUrl) window.open(data.signedUrl,"_blank");
  }
  async function deleteTicket(id) {
    if (!window.confirm(`Delete ticket ${id}? This cannot be undone.`)) return;
    await supabase.from("tickets").delete().eq("id",id);
    setTickets(p=>p.filter(t=>t.id!==id));
    setSelId(null); setView("list");
  }
  function openTicket(t) { setSelId(t.id); setEditCust(false); setEditTicket(false); setEditingCommentId(null); setUnreadTicketIds(prev=>{const next=new Set(prev);next.delete(t.id);return next;}); setView("detail"); }
  async function signOut() { await supabase.auth.signOut(); }

  const card={background:B.white,borderRadius:10,padding:22,boxShadow:"0 1px 6px rgba(0,0,0,0.08)",marginBottom:14};
  const inp={width:"100%",border:`1.5px solid ${B.border}`,borderRadius:7,padding:"9px 12px",fontSize:13,outline:"none",fontFamily:"inherit",boxSizing:"border-box",background:B.white};
  const btn={padding:"7px 16px",borderRadius:6,fontSize:13,fontWeight:600,cursor:"pointer",border:"none",fontFamily:"inherit"};
  const btnB={...btn,background:B.blue,color:B.white};
  const btnDark={...btn,background:B.blueDark,color:B.white};
  const btnO={...btn,background:B.white,color:B.charcoal,border:`1.5px solid ${B.border}`};
  const lbl={display:"block",fontSize:12,fontWeight:600,color:B.charcoal,marginBottom:5};
  const lblOpt={...lbl,color:B.lightGrey};
  const grid2={display:"grid",gridTemplateColumns:"1fr 1fr",gap:14};

  function formatFileSize(bytes) {
    if (!bytes) return "";
    if (bytes<1024) return `${bytes} B`;
    if (bytes<1024*1024) return `${(bytes/1024).toFixed(0)} KB`;
    return `${(bytes/1024/1024).toFixed(1)} MB`;
  }

  return (
    <div style={{fontFamily:"'Inter','Segoe UI',sans-serif",background:B.offWhite,minHeight:"100vh",color:B.black}}>
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap" rel="stylesheet"/>

      <header style={{background:B.black,height:56,display:"flex",alignItems:"center",justifyContent:"space-between",padding:"0 28px",position:"sticky",top:0,zIndex:100,boxShadow:"0 2px 10px rgba(0,0,0,0.4)"}}>
        <div style={{display:"flex",alignItems:"center",gap:14}}>
          <VoltexLogo height={24}/>
          <div style={{width:1,height:18,background:"rgba(255,255,255,0.2)"}}/>
          <span style={{fontSize:12,color:"rgba(255,255,255,0.5)",fontWeight:500,letterSpacing:"0.05em"}}>PRODUCT TECH SUPPORT</span>
        </div>
        <nav style={{display:"flex",gap:2,alignItems:"center"}}>
          {[{k:"board",l:"Dashboard"},{k:"list",l:"All Tickets"},{k:"product",l:"Product"}].map(n=>(
            <button key={n.k} onClick={()=>setView(n.k)}
              style={{background:"none",border:"none",color:view===n.k?B.white:"rgba(255,255,255,0.5)",cursor:"pointer",padding:"6px 14px",fontSize:13,fontWeight:view===n.k?700:400,borderBottom:`2px solid ${view===n.k?"rgba(255,255,255,0.9)":"transparent"}`,paddingBottom:4}}>
              {n.l}
            </button>
          ))}
          {unreadCount > 0 && (
            <button onClick={()=>setView("list")} style={{background:"none",border:"none",cursor:"pointer",position:"relative",padding:"4px 8px",display:"flex",alignItems:"center"}}>
              <span style={{fontSize:18}}>🔔</span>
              <span style={{position:"absolute",top:0,right:0,background:B.blue,color:B.white,borderRadius:"50%",fontSize:10,fontWeight:800,minWidth:16,height:16,display:"flex",alignItems:"center",justifyContent:"center",padding:"0 3px"}}>{unreadCount}</span>
            </button>
          )}
        </nav>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <span style={{fontSize:12,color:"rgba(255,255,255,0.45)"}}>{userName}</span>
          <button style={{...btnB,display:"flex",alignItems:"center",gap:6,fontWeight:700}} onClick={()=>setView("new")}>
            <span style={{fontSize:17,lineHeight:1}}>+</span> New Ticket
          </button>
          <button onClick={signOut} style={{background:"none",border:"1.5px solid rgba(255,255,255,0.2)",color:"rgba(255,255,255,0.5)",cursor:"pointer",padding:"5px 10px",borderRadius:6,fontSize:12}}>
            Sign out
          </button>
        </div>
      </header>

      {notifPermission==="default" && (
        <div style={{background:B.blue,padding:"10px 28px",display:"flex",alignItems:"center",justifyContent:"space-between",position:"relative",zIndex:200}}>
          <span style={{color:"#fff",fontSize:13,fontWeight:500}}>🔔 Enable notifications to be alerted when new tickets or replies come in.</span>
          <button onClick={()=>{ Notification.requestPermission().then(r=>setNotifPermission(r)); }}
            style={{background:"#fff",color:B.blue,border:"none",borderRadius:6,padding:"6px 16px",fontSize:13,fontWeight:700,cursor:"pointer",flexShrink:0,marginLeft:16,position:"relative",zIndex:201}}>
            Enable Now
          </button>
        </div>
      )}

      <main style={{maxWidth:1120,margin:"0 auto",padding:"26px 18px"}}>
        {loading ? <Spinner/> : <>

        {view==="board" && <>
          <div style={{marginBottom:22}}><h1 style={{fontSize:22,fontWeight:800,margin:0}}>Product Tech Support</h1></div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:12,marginBottom:26}}>
            {[{l:"Open",v:stats.open,accent:B.blue},{l:"In Progress",v:stats.inProgress,accent:"#FF6D00"},{l:"Awaiting",v:stats.awaiting,accent:"#0097A7"},{l:"Resolved",v:stats.resolved,accent:"#388E3C"},{l:"Urgent",v:stats.urgent,accent:"#E53935"}].map(s=>(
              <div key={s.l} style={{...card,marginBottom:0,padding:"16px 18px",borderLeft:`4px solid ${s.accent}`}}>
                <div style={{fontSize:32,fontWeight:900,color:s.accent,lineHeight:1}}>{s.v}</div>
                <div style={{fontSize:11,color:B.midGrey,marginTop:5,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.06em"}}>{s.l}</div>
              </div>
            ))}
          </div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14}}>
            {STATUSES.map(status => {
              const cols = tickets.filter(t=>t.status===status);
              const isResolved = status === "Resolved";
              const isExpanded = isResolved ? resolvedExpanded : true;
              return (
                <div key={status}>
                  <div
                    style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:10,cursor:isResolved?"pointer":"default",userSelect:"none"}}
                    onClick={isResolved?()=>setResolvedExpanded(e=>!e):undefined}>
                    <div style={{display:"flex",alignItems:"center",gap:6}}>
                      {isResolved && <span style={{fontSize:11,color:B.lightGrey,transition:"transform 0.2s",display:"inline-block",transform:resolvedExpanded?"rotate(90deg)":"rotate(0deg)"}}>{resolvedExpanded?"▼":"▶"}</span>}
                      <span style={{fontSize:11,fontWeight:700,color:B.midGrey,textTransform:"uppercase",letterSpacing:"0.07em"}}>{status}</span>
                    </div>
                    <span style={{background:B.blue,color:B.white,borderRadius:20,fontSize:10,fontWeight:700,padding:"1px 7px"}}>{cols.length}</span>
                  </div>
                  {isResolved && !resolvedExpanded ? (
                    <div onClick={()=>setResolvedExpanded(true)} style={{background:B.white,borderRadius:8,padding:14,fontSize:12,color:B.lightGrey,textAlign:"center",border:`1.5px dashed ${B.border}`,cursor:"pointer"}}
                      onMouseEnter={e=>e.currentTarget.style.background=B.blueLight}
                      onMouseLeave={e=>e.currentTarget.style.background=B.white}>
                      {cols.length} resolved ticket{cols.length!==1?"s":""} — click to expand
                    </div>
                  ) : (
                    <div style={{display:"flex",flexDirection:"column",gap:8}}>
                      {cols.length===0 && <div style={{background:B.white,borderRadius:8,padding:16,fontSize:12,color:B.border,textAlign:"center",border:`1.5px dashed ${B.border}`}}>No tickets</div>}
                      {cols.map(t=>(
                        <div key={t.id} onClick={()=>openTicket(t)}
                          style={{background:B.white,borderRadius:8,padding:"12px 14px",cursor:"pointer",borderLeft:`3px solid ${PRIORITY_COLORS[t.priority].dot}`,boxShadow:"0 1px 4px rgba(0,0,0,0.07)",transition:"box-shadow 0.15s,transform 0.1s"}}
                          onMouseEnter={e=>{e.currentTarget.style.boxShadow="0 4px 16px rgba(15,107,255,0.18)";e.currentTarget.style.transform="translateY(-1px)";}}
                          onMouseLeave={e=>{e.currentTarget.style.boxShadow="0 1px 4px rgba(0,0,0,0.07)";e.currentTarget.style.transform="none";}}>
                          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:3}}>
                            <div style={{fontSize:10,color:B.lightGrey,fontWeight:700}}>{t.id}</div>
                            {unreadTicketIds.has(t.id) && <span style={{fontSize:13}}>🔔</span>}
                          </div>
                          <div style={{fontSize:13,fontWeight:600,marginBottom:7,lineHeight:1.4}}>{t.title}</div>
                          {(t.customer?.name||t.customer?.company) && <div style={{fontSize:11,color:B.darkGrey,marginBottom:7}}>👤 {t.customer.name}{t.customer.company?` · ${t.customer.company}`:""}</div>}
                          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                            <PriorityBadge p={t.priority}/>
                            <span style={{fontSize:11,color:B.lightGrey}}>{t.assignedTo||"Unassigned"}</span>
                          </div>
                          <div style={{fontSize:11,color:B.lightGrey,marginTop:6}}>{t.submittedBy}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </>}

        {view==="list" && <>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
            <h1 style={{fontSize:22,fontWeight:800,margin:0}}>All Tickets</h1>
            <div style={{display:"flex",alignItems:"center",gap:12}}>
              {selectedIds.size > 0 && (
                <button style={{...btn,background:"#FDECEA",color:"#B71C1C",border:"1.5px solid #FFCDD2",fontSize:13}}
                  onClick={async()=>{
                    if(!window.confirm(`Delete ${selectedIds.size} ticket${selectedIds.size!==1?"s":""}? This cannot be undone.`)) return;
                    for(const id of selectedIds) { await supabase.from("tickets").delete().eq("id",id); }
                    setTickets(p=>p.filter(t=>!selectedIds.has(t.id)));
                    setSelectedIds(new Set());
                  }}>🗑 Delete {selectedIds.size} Selected</button>
              )}
              <span style={{fontSize:13,color:B.midGrey}}>{filtered.length} ticket{filtered.length!==1?"s":""} shown</span>
            </div>
          </div>
          <div style={{...card,display:"flex",gap:10,alignItems:"center",flexWrap:"wrap",padding:"12px 16px"}}>
            <input style={{...inp,width:220}} placeholder="Search by title, ID, customer…" value={search} onChange={e=>setSearch(e.target.value)}/>
            {[{v:fStatus,s:setFStatus,o:STATUSES,p:"All Statuses"},{v:fPriority,s:setFPriority,o:PRIORITIES,p:"All Priorities"},{v:fCategory,s:setFCategory,o:CATEGORIES,p:"All Categories"},{v:fCountry,s:setFCountry,o:["AU","NZ"],p:"All Countries"}].map((f,i)=>(
              <select key={i} style={{...inp,width:"auto",cursor:"pointer"}} value={f.v} onChange={e=>f.s(e.target.value)}>
                <option value="All">{f.p}</option>
                {f.o.map(o=><option key={o}>{o}</option>)}
              </select>
            ))}
            {(fStatus!=="All"||fPriority!=="All"||fCategory!=="All"||fCountry!=="All"||search) && <button style={{...btnO,fontSize:12}} onClick={()=>{setFStatus("All");setFPriority("All");setFCategory("All");setFCountry("All");setSearch("");}}>Clear</button>}
          </div>
          <div style={{...card,padding:0,overflow:"hidden"}}>
            <table style={{width:"100%",borderCollapse:"collapse"}}>
              <thead>
                <tr style={{background:B.blue}}>
                  <th style={{padding:"11px 14px",width:36}}>
                    <input type="checkbox"
                      checked={filtered.length>0&&filtered.every(t=>selectedIds.has(t.id))}
                      onChange={e=>{if(e.target.checked)setSelectedIds(new Set(filtered.map(t=>t.id)));else setSelectedIds(new Set());}}
                      style={{cursor:"pointer",width:15,height:15}}
                      onClick={e=>e.stopPropagation()}/>
                  </th>
                  {["ID","Title","Customer","Category","Priority","Status","Submitted By","Assigned To","Created"].map(h=>(
                    <th key={h} style={{textAlign:"left",padding:"11px 14px",fontSize:11,fontWeight:700,color:"rgba(255,255,255,0.8)",textTransform:"uppercase",letterSpacing:"0.07em",whiteSpace:"nowrap"}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.length===0 && <tr><td colSpan={10} style={{padding:32,textAlign:"center",color:B.lightGrey,fontSize:13}}>No tickets found.</td></tr>}
                {filtered.map((t,i)=>(
                  <tr key={t.id} style={{borderBottom:`1px solid ${B.border}`,cursor:"pointer",background:selectedIds.has(t.id)?"#EBF2FA":i%2===0?B.white:B.offWhite}}
                    onClick={()=>openTicket(t)}
                    onMouseEnter={e=>{if(!selectedIds.has(t.id))e.currentTarget.style.background=B.blueLight;}}
                    onMouseLeave={e=>{if(!selectedIds.has(t.id))e.currentTarget.style.background=i%2===0?B.white:B.offWhite;}}>
                    <td style={{padding:"11px 14px",width:36}} onClick={e=>e.stopPropagation()}>
                      <input type="checkbox" checked={selectedIds.has(t.id)}
                        onChange={e=>{const next=new Set(selectedIds);if(e.target.checked)next.add(t.id);else next.delete(t.id);setSelectedIds(next);}}
                        style={{cursor:"pointer",width:15,height:15}}/>
                    </td>
                    <td style={{padding:"11px 14px",fontSize:12,fontWeight:700,color:B.midGrey}}>{t.id}</td>
                    <td style={{padding:"11px 14px",fontSize:13,fontWeight:600,maxWidth:200}}><div style={{display:"flex",alignItems:"center",gap:6}}>{t.title}{unreadTicketIds.has(t.id)&&<span style={{fontSize:13}}>🔔</span>}</div></td>
                    <td style={{padding:"11px 14px",maxWidth:160}}>
                      {t.customer?.name?<><div style={{fontWeight:500,fontSize:13}}>{t.customer.name}</div><div style={{fontSize:11,color:B.lightGrey}}>{t.customer.company}</div></>:<span style={{color:B.border,fontStyle:"italic",fontSize:12}}>—</span>}
                    </td>
                    <td style={{padding:"11px 14px",fontSize:12,color:B.midGrey}}>{t.category}</td>
                    <td style={{padding:"11px 14px"}}><PriorityBadge p={t.priority}/></td>
                    <td style={{padding:"11px 14px"}}><StatusBadge s={t.status}/></td>
                    <td style={{padding:"11px 14px",fontSize:13}}>{t.submittedBy}</td>
                    <td style={{padding:"11px 14px",fontSize:13,color:t.assignedTo?B.black:B.lightGrey,fontStyle:t.assignedTo?"normal":"italic"}}>{t.assignedTo||"—"}</td>
                    <td style={{padding:"11px 14px",fontSize:12,color:B.midGrey,whiteSpace:"nowrap"}}>{formatDate(t.created)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>}

        {view==="product" && <>
          <div style={{marginBottom:22}}><h1 style={{fontSize:22,fontWeight:800,margin:0}}>Product Search</h1></div>
          <div style={{maxWidth:600,margin:"0 auto"}}>
            <div style={{position:"relative",marginBottom:24}}>
              <input
                style={{...inp,fontSize:15,padding:"12px 16px"}}
                placeholder="Enter a product code to find previous tickets…"
                value={productSearch}
                onChange={e=>{
                  const val=e.target.value;
                  setProductSearch(val);
                  if(val.length>=1){
                    const matches=PRODUCT_CODES.filter(c=>c.toLowerCase().includes(val.toLowerCase())).slice(0,8);
                    setProductSuggestions(matches);
                    setShowSuggestions(matches.length>0);
                  } else {
                    setShowSuggestions(false);
                  }
                }}
                onBlur={()=>setTimeout(()=>setShowSuggestions(false),150)}
                onFocus={()=>{
                  if(productSearch.length>=1){
                    const matches=PRODUCT_CODES.filter(c=>c.toLowerCase().includes(productSearch.toLowerCase())).slice(0,8);
                    setProductSuggestions(matches);
                    setShowSuggestions(matches.length>0);
                  }
                }}
              />
              {showSuggestions && (
                <div style={{position:"absolute",top:"100%",left:0,right:0,background:B.white,border:`1.5px solid ${B.blue}`,borderTop:"none",borderRadius:"0 0 8px 8px",zIndex:50,boxShadow:"0 4px 16px rgba(0,0,0,0.1)"}}>
                  {productSuggestions.map(s=>(
                    <div key={s}
                      style={{padding:"10px 16px",cursor:"pointer",fontSize:13,fontWeight:600,borderBottom:`1px solid ${B.border}`}}
                      onMouseDown={()=>{setProductSearch(s);setShowSuggestions(false);}}
                      onMouseEnter={e=>e.currentTarget.style.background=B.blueLight}
                      onMouseLeave={e=>e.currentTarget.style.background=B.white}>
                      {s}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {productSearch.trim() && (()=>{
              const q = productSearch.trim().toLowerCase();
              const results = tickets.filter(t=>t.title.toLowerCase().includes(q));
              return results.length===0
                ? <div style={{textAlign:"center",color:B.lightGrey,fontSize:14,padding:40,fontStyle:"italic"}}>No tickets found for "{productSearch}"</div>
                : <>
                    <div style={{fontSize:13,color:B.midGrey,marginBottom:12}}>{results.length} ticket{results.length!==1?"s":""} found for <strong>{productSearch}</strong></div>
                    <div style={{display:"flex",flexDirection:"column",gap:10}}>
                      {results.map(t=>(
                        <div key={t.id} onClick={()=>openTicket(t)}
                          style={{...card,marginBottom:0,cursor:"pointer",borderLeft:`4px solid ${PRIORITY_COLORS[t.priority].dot}`,padding:"14px 18px"}}
                          onMouseEnter={e=>e.currentTarget.style.background=B.blueLight}
                          onMouseLeave={e=>e.currentTarget.style.background=B.white}>
                          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                            <div>
                              <div style={{fontSize:11,color:B.lightGrey,fontWeight:700,marginBottom:2}}>{t.id}</div>
                              <div style={{fontSize:14,fontWeight:700}}>{t.title}</div>
                            </div>
                            <div style={{display:"flex",gap:6,alignItems:"center",flexShrink:0}}>
                              <PriorityBadge p={t.priority}/>
                              <StatusBadge s={t.status}/>
                            </div>
                          </div>
                          <div style={{fontSize:12,color:B.midGrey,marginBottom:6}}>{t.category} · {t.submittedBy} · {formatDate(t.created)}</div>
                          {t.description && <div style={{fontSize:12,color:B.darkGrey,background:B.offWhite,borderRadius:6,padding:"8px 10px",marginBottom:t.comments.length>0?8:0,lineHeight:1.5}}>{t.description.slice(0,120)}{t.description.length>120?"…":""}</div>}
                          {t.comments.length>0 && (
                            <div style={{fontSize:12,color:B.midGrey}}>💬 {t.comments.length} comment{t.comments.length!==1?"s":""}{t.status==="Resolved"?" · Last reply: "+t.comments[t.comments.length-1].text.slice(0,60)+(t.comments[t.comments.length-1].text.length>60?"…":""):""}</div>
                          )}
                        </div>
                      ))}
                    </div>
                  </>;
            })()}
          </div>
        </>}

        {view==="detail" && live && (()=>{
          const cust=live.customer||{};
          const hasCust=!!(cust.name||cust.company||cust.phone||cust.email);
          return <>
            <button style={{background:"none",border:"none",color:B.blue,cursor:"pointer",fontSize:13,fontWeight:600,display:"flex",alignItems:"center",gap:5,marginBottom:18,padding:0}} onClick={()=>setView("list")}>← Back to tickets</button>
            <div style={{display:"grid",gridTemplateColumns:"1fr 278px",gap:16,alignItems:"start"}}>
              <div>
                <div style={{...card,borderTop:`4px solid ${B.blue}`}}>
                  <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",marginBottom:14}}>
                    <div style={{flex:1}}>
                      <div style={{fontSize:11,fontWeight:700,color:B.lightGrey,letterSpacing:"0.06em",marginBottom:4}}>{live.id}</div>
                      {!editTicket && <div style={{fontSize:20,fontWeight:800,lineHeight:1.3}}>{live.title}</div>}
                    </div>
                    <div style={{display:"flex",alignItems:"center",gap:8,flexShrink:0,marginLeft:12}}>
                      <StatusBadge s={live.status}/>
                      {!editTicket && (
                        <button style={{...btnO,padding:"4px 10px",fontSize:11}} onClick={()=>{setTicketDraft({title:live.title,category:live.category,priority:live.priority,description:live.description});setEditTicket(true);}}>
                          Edit
                        </button>
                      )}
                    </div>
                  </div>
                  {editTicket ? <>
                    <div style={{marginBottom:12}}>
                      <label style={lbl}>Product Code</label>
                      <input style={inp} value={ticketDraft.title} onChange={e=>setTicketDraft(d=>({...d,title:e.target.value}))}/>
                    </div>
                    <div style={{...grid2,marginBottom:12}}>
                      <div>
                        <label style={lbl}>Category</label>
                        <select style={{...inp,cursor:"pointer"}} value={ticketDraft.category} onChange={e=>setTicketDraft(d=>({...d,category:e.target.value}))}>
                          {CATEGORIES.map(c=><option key={c}>{c}</option>)}
                        </select>
                      </div>
                      <div>
                        <label style={lbl}>Priority</label>
                        <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                          {PRIORITIES.map(p=>(
                            <button key={p} type="button"
                              style={{...btn,...(ticketDraft.priority===p?{background:PRIORITY_COLORS[p].dot,color:B.white}:btnO),fontSize:12,padding:"5px 10px"}}
                              onClick={()=>setTicketDraft(d=>({...d,priority:p}))}>{p}</button>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div style={{marginBottom:14}}>
                      <label style={lbl}>Description</label>
                      <textarea style={{...inp,resize:"vertical",minHeight:80}} value={ticketDraft.description} onChange={e=>setTicketDraft(d=>({...d,description:e.target.value}))}/>
                    </div>
                    <div style={{display:"flex",gap:8}}>
                      <button style={btnB} disabled={savingTicket} onClick={()=>saveTicketEdit(live.id)}>{savingTicket?"Saving…":"Save"}</button>
                      <button style={btnO} onClick={()=>setEditTicket(false)}>Cancel</button>
                    </div>
                  </> : <>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px 28px",marginBottom:16}}>
                      {[["Category",live.category],["Priority",null],["Submitted By",live.submittedBy],["Created",formatDate(live.created)]].map(([l,v])=>(
                        <div key={l}>
                          <div style={{fontSize:10,fontWeight:700,color:B.lightGrey,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:3}}>{l}</div>
                          <div style={{fontSize:13,fontWeight:500}}>{l==="Priority"?<PriorityBadge p={live.priority}/>:v}</div>
                        </div>
                      ))}
                    </div>
                    <SecLabel>Description</SecLabel>
                    <div style={{fontSize:13,lineHeight:1.75,color:"#333",background:B.offWhite,borderRadius:7,padding:"11px 14px",border:`1px solid ${B.border}`}}>{live.description}</div>
                  </>}
                </div>

                <div style={card}>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:editCust?14:4}}>
                    <SecLabel style={{marginBottom:0}}>Customer Details</SecLabel>
                    {!editCust && <button style={{...btnO,padding:"4px 10px",fontSize:11}} onClick={()=>{setCustDraft({...EMPTY_CUST,...cust});setEditCust(true);}}>{hasCust?"Edit":"+ Add"}</button>}
                  </div>
                  {editCust ? <>
                    <div style={{...grid2,marginTop:12}}>
                      {[{k:"name",l:"Name",p:"Customer name"},{k:"company",l:"Company",p:"Business name"},{k:"phone",l:"Phone",p:"e.g. 0412 345 678"},{k:"email",l:"Email",p:"customer@example.com"}].map(f=>(
                        <div key={f.k} style={{marginBottom:12}}>
                          <label style={lbl}>{f.l}</label>
                          <input style={inp} placeholder={f.p} value={custDraft[f.k]} onChange={e=>setCustDraft(d=>({...d,[f.k]:e.target.value}))}/>
                        </div>
                      ))}
                      <div style={{marginBottom:12}}>
                        <label style={lbl}>Country</label>
                        <select style={{...inp,cursor:"pointer"}} value={custDraft.country||"AU"} onChange={e=>setCustDraft(d=>({...d,country:e.target.value}))}>
                          <option value="AU">AU</option>
                          <option value="NZ">NZ</option>
                        </select>
                      </div>
                    </div>
                    <div style={{marginBottom:14}}>
                      <label style={lbl}>Contact Notes</label>
                      <input style={inp} placeholder="e.g. Prefers a call, best after 2pm" value={custDraft.notes} onChange={e=>setCustDraft(d=>({...d,notes:e.target.value}))}/>
                    </div>
                    <div style={{display:"flex",gap:8}}>
                      <button style={btnB} disabled={savingCust} onClick={()=>saveCustomer(live.id)}>{savingCust?"Saving…":"Save"}</button>
                      <button style={btnO} onClick={()=>setEditCust(false)}>Cancel</button>
                    </div>
                  </> : hasCust ? <>
                    {[{icon:"👤",l:"Name",v:cust.name,href:null},{icon:"🏢",l:"Company",v:cust.company,href:null},{icon:"📞",l:"Phone",v:cust.phone,href:cust.phone?`tel:${cust.phone}`:null},{icon:"✉️",l:"Email",v:cust.email,href:cust.email?`mailto:${cust.email}`:null},{icon:"🌏",l:"Country",v:cust.country||"AU",href:null}].filter(r=>r.v).map(row=>(
                      <div key={row.l} style={{display:"flex",alignItems:"flex-start",gap:8,padding:"7px 0",borderBottom:`1px solid ${B.offWhite}`}}>
                        <span style={{width:20,textAlign:"center",flexShrink:0}}>{row.icon}</span>
                        <span style={{fontSize:11,fontWeight:600,color:B.lightGrey,width:62,flexShrink:0,paddingTop:2}}>{row.l}</span>
                        {row.href?<a href={row.href} style={{fontSize:13,fontWeight:500,color:B.blue,textDecoration:"none"}}>{row.v}</a>:<span style={{fontSize:13,fontWeight:500}}>{row.v}</span>}
                      </div>
                    ))}
                    {cust.notes && <div style={{marginTop:10,background:B.blueLight,border:`1px solid ${B.blueMid}`,borderRadius:6,padding:"8px 12px",fontSize:12,color:B.blueDark,display:"flex",gap:6}}><span>📝</span><span>{cust.notes}</span></div>}
                  </> : <div style={{fontSize:13,color:B.lightGrey,fontStyle:"italic"}}>No customer details added yet.</div>}
                </div>

                <div style={card}>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:10}}>
                    <SecLabel style={{marginBottom:0}}>Attachments ({live.attachments?.length||0})</SecLabel>
                    <label style={{...btnO,padding:"4px 10px",fontSize:11,cursor:"pointer",display:"inline-block"}}>
                      {uploading?"Uploading…":"+ Add File"}
                      <input type="file" accept=".pdf,.png,.jpg,.jpeg,.gif,.webp,.mp4,.mov,.avi,.mkv,.doc,.docx,.xls,.xlsx" style={{display:"none"}}
                        onChange={e=>{if(e.target.files[0])uploadFile(live.id,e.target.files[0]);e.target.value="";}} disabled={uploading}/>
                    </label>
                  </div>
                  {(!live.attachments||live.attachments.length===0)
                    ? <div style={{fontSize:13,color:B.lightGrey,fontStyle:"italic"}}>No attachments yet.</div>
                    : <div style={{display:"flex",flexDirection:"column",gap:6}}>
                        {live.attachments.map(a=>(
                          <div key={a.id} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 10px",background:B.offWhite,borderRadius:6,border:`1px solid ${B.border}`}}>
                            <span style={{fontSize:18}}>{a.type?.includes("pdf")?"📄":a.type?.includes("image")?"🖼️":a.type?.includes("video")?"🎥":"📎"}</span>
                            <div style={{flex:1,minWidth:0}}>
                              <div style={{fontSize:13,fontWeight:500,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.name}</div>
                              <div style={{fontSize:11,color:B.lightGrey}}>{formatFileSize(a.size)} · {a.uploadedBy} · {formatDate(a.time)}</div>
                            </div>
                            <button style={{...btnB,padding:"4px 10px",fontSize:11}} onClick={()=>getFileUrl(a.path)}>Open</button>
                          </div>
                        ))}
                      </div>
                  }
                </div>

                <div style={card}>
                  <SecLabel>Comments ({live.comments.length})</SecLabel>
                  <div style={{borderTop:`1px solid ${B.border}`,paddingTop:14}}>
                    {live.comments.length===0 && <div style={{color:B.lightGrey,fontSize:13,marginBottom:14}}>No comments yet.</div>}
                    {live.comments.map((c,i)=>(
                      <div key={i} style={{display:"flex",gap:10,marginBottom:14}}>
                        <Avatar name={c.author}/>
                        <div style={{flex:1}}>
                          <div style={{fontSize:11,color:B.lightGrey,marginBottom:3,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                            <span><strong style={{color:B.charcoal}}>{c.author}</strong> · {formatDate(c.time)}</span>
                            {c.author === userName && editingCommentId !== c.id && (
                              <div style={{display:"flex",gap:6}}>
                                <button onClick={()=>{setEditingCommentId(c.id);setEditingCommentText(c.text);}}
                                  style={{background:"none",border:"none",color:B.blue,cursor:"pointer",fontSize:11,fontWeight:600,padding:"0 4px"}}>Edit</button>
                                <button onClick={()=>deleteComment(c.id,live.id)}
                                  style={{background:"none",border:"none",color:"#B71C1C",cursor:"pointer",fontSize:11,fontWeight:600,padding:"0 4px"}}>Delete</button>
                              </div>
                            )}
                          </div>
                          {editingCommentId === c.id ? (
                            <div>
                              <textarea style={{...inp,resize:"vertical",minHeight:60,marginBottom:8}} value={editingCommentText} onChange={e=>setEditingCommentText(e.target.value)}/>
                              <div style={{display:"flex",gap:8}}>
                                <button style={{...btnB,padding:"5px 12px",fontSize:12}} disabled={savingComment} onClick={()=>saveCommentEdit(c.id,live.id)}>{savingComment?"Saving…":"Save"}</button>
                                <button style={{...btnO,padding:"5px 12px",fontSize:12}} onClick={()=>{setEditingCommentId(null);setEditingCommentText("");}}>Cancel</button>
                              </div>
                            </div>
                          ) : (
                            <div style={{background:B.offWhite,borderRadius:"0 7px 7px 7px",padding:"9px 12px",fontSize:13,lineHeight:1.6,border:`1px solid ${B.border}`}}>{c.text}</div>
                          )}
                        </div>
                      </div>
                    ))}
                    <div style={{display:"flex",gap:10,alignItems:"flex-start",marginTop:12}}>
                      <Avatar name={userName}/>
                      <div style={{flex:1}}>
                        <textarea style={{...inp,resize:"vertical",minHeight:76}} placeholder="Add a reply or answer…" value={comment} onChange={e=>setComment(e.target.value)}/>
                        <div style={{display:"flex",gap:8,marginTop:8,alignItems:"center",flexWrap:"wrap"}}>
                          <button style={btnDark} disabled={posting} onClick={()=>postComment(live.id)}>{posting?"Posting…":"Post Reply"}</button>
                          {live.status!=="Resolved" && <button style={btnB} disabled={posting} onClick={()=>postComment(live.id,true)}>Post &amp; Mark Resolved</button>}
                          <select value={notifyUser} onChange={e=>setNotifyUser(e.target.value)}
                            style={{...inp,width:"auto",cursor:"pointer",fontSize:12,padding:"6px 10px",color:notifyUser?B.black:B.lightGrey}}>
                            <option value="">Also Notify…</option>
                            {allUsers.map(u=>(<option key={u} value={u}>{u}</option>))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div style={card}>
                  <SecLabel>Update Status</SecLabel>
                  <div style={{display:"flex",flexDirection:"column",gap:6}}>
                    {STATUSES.map(st=>(
                      <button key={st} style={{...btn,...(live.status===st?btnB:btnO),textAlign:"left",fontSize:12}} onClick={()=>updateStatus(live.id,st)}>{live.status===st?"✓ ":""}{st}</button>
                    ))}
                  </div>
                </div>
                <div style={card}>
                  <SecLabel>Assign To</SecLabel>
                  <div style={{display:"flex",flexDirection:"column",gap:6}}>
                    {["Scott","Adam"].map(name=>(
                      <button key={name} style={{...btn,...(live.assignedTo===name?btnDark:btnO),textAlign:"left",fontSize:12}} onClick={()=>assignTicket(live.id,name)}>{live.assignedTo===name?"✓ ":""}{name}</button>
                    ))}
                    {live.assignedTo && <button style={{...btnO,fontSize:11,color:B.lightGrey}} onClick={()=>assignTicket(live.id,"")}>Unassign</button>}
                  </div>
                </div>
                <div style={card}>
                  <SecLabel>Ticket Info</SecLabel>
                  <div style={{fontSize:12,color:B.midGrey,lineHeight:2.2}}>
                    <div><strong>ID:</strong> {live.id}</div>
                    <div><strong>Category:</strong> {live.category}</div>
                    <div><strong>Comments:</strong> {live.comments.length}</div>
                    <div><strong>Attachments:</strong> {live.attachments?.length||0}</div>
                    <div><strong>Submitted by:</strong> {live.submittedBy}</div>
                  </div>
                </div>
                <div style={card}>
                  <SecLabel>Danger Zone</SecLabel>
                  <button style={{...btn,width:"100%",background:"#FDECEA",color:"#B71C1C",border:"1.5px solid #FFCDD2",fontSize:12,textAlign:"left"}} onClick={()=>deleteTicket(live.id)}>
                    🗑 Delete Ticket
                  </button>
                </div>
              </div>
            </div>
          </>;
        })()}

        {view==="new" && <>
          <button style={{background:"none",border:"none",color:B.blue,cursor:"pointer",fontSize:13,fontWeight:600,display:"flex",alignItems:"center",gap:5,marginBottom:18,padding:0}} onClick={()=>setView("list")}>← Back to tickets</button>
          <div style={{...card,maxWidth:720,margin:"0 auto",padding:0,overflow:"hidden"}}>
            <div style={{background:B.black,padding:"16px 24px",display:"flex",alignItems:"center",gap:12}}>
              <VoltexLogo height={22}/>
              <div style={{width:1,height:16,background:"rgba(255,255,255,0.25)"}}/>
              <span style={{fontSize:13,color:"rgba(255,255,255,0.6)",fontWeight:500}}>Submit a New Ticket</span>
            </div>
            <div style={{padding:24}}>
              {formErr && <div style={{background:"#FDECEA",color:"#B71C1C",border:"1px solid #FFCDD2",borderRadius:6,padding:"8px 12px",fontSize:13,marginBottom:14}}>{formErr}</div>}
              <div style={{marginBottom:14}}>
                <label style={lbl}>Your Name *</label>
                <input style={inp} placeholder="e.g. Rhi" value={form.submittedBy} onChange={e=>setForm(f=>({...f,submittedBy:e.target.value}))}/>
              </div>
              <div style={{...grid2,marginBottom:14}}>
                <div>
                  <label style={lbl}>Category *</label>
                  <select style={{...inp,cursor:"pointer"}} value={form.category} onChange={e=>setForm(f=>({...f,category:e.target.value}))}>
                    {CATEGORIES.map(c=><option key={c}>{c}</option>)}
                  </select>
                </div>
                <div>
                  <label style={lbl}>Priority</label>
                  <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                    {PRIORITIES.map(p=>(
                      <button key={p} type="button"
                        style={{...btn,...(form.priority===p?{background:PRIORITY_COLORS[p].dot,color:B.white}:btnO),fontSize:12,padding:"6px 11px"}}
                        onClick={()=>setForm(f=>({...f,priority:p}))}>{p}</button>
                    ))}
                  </div>
                </div>
              </div>
              <div style={{marginBottom:14}}>
                <label style={lbl}>Product Code *</label>
                <input style={inp} placeholder="Enter product code" value={form.title} onChange={e=>setForm(f=>({...f,title:e.target.value}))}/>
              </div>
              <div style={{marginBottom:14}}>
                <label style={lbl}>Details *</label>
                <textarea style={{...inp,resize:"vertical",minHeight:90}} placeholder="Include product codes, batch numbers, and any other relevant details." value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))}/>
              </div>
              <div style={{marginBottom:14}}>
                <label style={lbl}>Attachments <span style={{fontWeight:400,color:B.lightGrey,fontSize:11}}>(optional — PDFs, photos, screenshots, videos)</span></label>
                <label style={{display:"inline-flex",alignItems:"center",gap:8,...btnO,cursor:"pointer",fontSize:12,marginBottom:pendingFiles.length>0?10:0}}>
                  + Add Files
                  <input type="file" multiple accept=".pdf,.png,.jpg,.jpeg,.gif,.webp,.mp4,.mov,.avi,.mkv,.doc,.docx,.xls,.xlsx" style={{display:"none"}}
                    onChange={e=>{const files=Array.from(e.target.files);setPendingFiles(prev=>[...prev,...files]);e.target.value="";}}/>
                </label>
                {pendingFiles.length > 0 && (
                  <div style={{display:"flex",flexDirection:"column",gap:6}}>
                    {pendingFiles.map((f,i)=>(
                      <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"7px 10px",background:B.offWhite,borderRadius:6,border:`1px solid ${B.border}`}}>
                        <span style={{fontSize:16}}>{f.type?.includes("pdf")?"📄":f.type?.includes("image")?"🖼️":f.type?.includes("video")?"🎥":"📎"}</span>
                        <span style={{fontSize:13,flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{f.name}</span>
                        <button type="button" onClick={()=>setPendingFiles(prev=>prev.filter((_,j)=>j!==i))}
                          style={{background:"none",border:"none",color:B.lightGrey,cursor:"pointer",fontSize:16,lineHeight:1,padding:"0 4px"}}>×</button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div style={{borderTop:`2px solid ${B.blueMid}`,marginTop:22,paddingTop:18}}>
                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}>
                  <span style={{fontSize:12,fontWeight:700,color:B.charcoal,textTransform:"uppercase",letterSpacing:"0.06em"}}>Customer Details</span>
                  <span style={{fontSize:11,color:B.lightGrey}}>(optional — fill in if follow-up may be needed)</span>
                </div>
                <div style={grid2}>
                  {[{k:"name",l:"Customer Name",p:"e.g. Greg Halliday"},{k:"company",l:"Company",p:"e.g. Halliday Electrical"},{k:"phone",l:"Phone",p:"e.g. 0412 345 678"},{k:"email",l:"Email",p:"customer@example.com"}].map(f=>(
                    <div key={f.k} style={{marginBottom:12}}>
                      <label style={lblOpt}>{f.l}</label>
                      <input style={inp} placeholder={f.p} value={form.customer[f.k]} onChange={e=>setForm(f2=>({...f2,customer:{...f2.customer,[f.k]:e.target.value}}))}/>
                    </div>
                  ))}
                  <div style={{marginBottom:12}}>
                    <label style={lblOpt}>Country</label>
                    <select style={{...inp,cursor:"pointer"}} value={form.customer.country||"AU"} onChange={e=>setForm(f=>({...f,customer:{...f.customer,country:e.target.value}}))}>
                      <option value="AU">AU</option>
                      <option value="NZ">NZ</option>
                    </select>
                  </div>
                </div>
                <div style={{marginBottom:18}}>
                  <label style={lblOpt}>Contact Notes</label>
                  <input style={inp} placeholder="e.g. Prefers a call, best after 2pm" value={form.customer.notes} onChange={e=>setForm(f=>({...f,customer:{...f.customer,notes:e.target.value}}))}/>
                </div>
              </div>
              <div style={{display:"flex",gap:8}}>
                <button style={{...btnB,fontSize:14,padding:"9px 26px",fontWeight:700}} disabled={submitting} onClick={submitTicket}>
                  {submitting?"Submitting…":"Submit Ticket"}
                </button>
                <button style={btnO} onClick={()=>setView("list")}>Cancel</button>
              </div>
            </div>
          </div>
        </>}

        </>}
      </main>

      <footer style={{borderTop:`1px solid ${B.border}`,padding:"14px 28px",display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:24}}>
        <span style={{fontSize:11,color:B.lightGrey,fontStyle:"italic",fontWeight:600}}>VOLTEX® Internal Product Tech Support</span>
        <span style={{fontSize:11,color:B.lightGrey}}>AU: 1300 722 275 · NZ: 0800 55 66 33</span>
      </footer>
    </div>
  );
}
